import { render, staticRenderFns } from "./materialrequest.vue?vue&type=template&id=e91b87fc&scoped=true&"
import script from "./materialrequest.vue?vue&type=script&lang=js&"
export * from "./materialrequest.vue?vue&type=script&lang=js&"
import style0 from "./materialrequest.vue?vue&type=style&index=0&id=e91b87fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e91b87fc",
  null
  
)

export default component.exports